import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var alpineNames = {
  enterFromClass: 'enter',
  enterActiveClass: 'enterStart',
  enterToClass: 'enterEnd',
  leaveFromClass: 'leave',
  leaveActiveClass: 'leaveStart',
  leaveToClass: 'leaveEnd'
};
var defaultOptions = {
  transitioned: false,
  hiddenClass: 'hidden',
  preserveOriginalClass: true,
  removeToClasses: true
};
export var useTransition = function useTransition(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b, _c;

  var targetName = controller.element.dataset.transitionTarget;
  var targetFromAttribute;

  if (targetName) {
    targetFromAttribute = controller["".concat(targetName, "Target")];
  }

  var targetElement = (options === null || options === void 0 ? void 0 : options.element) || targetFromAttribute || controller.element; // data attributes are only available on HTMLElement and SVGElement

  if (!(targetElement instanceof HTMLElement || targetElement instanceof SVGElement)) return;
  var dataset = targetElement.dataset;
  var leaveAfter = parseInt(dataset.leaveAfter || '') || options.leaveAfter || 0;

  var _Object$assign = Object.assign(defaultOptions, options),
      transitioned = _Object$assign.transitioned,
      hiddenClass = _Object$assign.hiddenClass,
      preserveOriginalClass = _Object$assign.preserveOriginalClass,
      removeToClasses = _Object$assign.removeToClasses;

  var controllerEnter = (_a = controller.enter) === null || _a === void 0 ? void 0 : _a.bind(controller);
  var controllerLeave = (_b = controller.leave) === null || _b === void 0 ? void 0 : _b.bind(controller);
  var controllerToggleTransition = (_c = controller.toggleTransition) === null || _c === void 0 ? void 0 : _c.bind(controller);

  function enter(_x) {
    return _enter.apply(this, arguments);
  }

  function _enter() {
    _enter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var enterFromClasses, enterActiveClasses, enterToClasses, leaveToClasses;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!controller.transitioned) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              controller.transitioned = true;
              controllerEnter && controllerEnter(event);
              enterFromClasses = getAttribute('enterFrom', options, dataset);
              enterActiveClasses = getAttribute('enterActive', options, dataset);
              enterToClasses = getAttribute('enterTo', options, dataset);
              leaveToClasses = getAttribute('leaveTo', options, dataset);

              if (!!hiddenClass) {
                targetElement.classList.remove(hiddenClass);
              }

              if (!removeToClasses) {
                removeClasses(targetElement, leaveToClasses);
              }

              _context.next = 12;
              return transition(targetElement, enterFromClasses, enterActiveClasses, enterToClasses, hiddenClass, preserveOriginalClass, removeToClasses);

            case 12:
              if (leaveAfter > 0) {
                setTimeout(function () {
                  leave(event);
                }, leaveAfter);
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _enter.apply(this, arguments);
  }

  function leave(_x2) {
    return _leave.apply(this, arguments);
  }

  function _leave() {
    _leave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
      var leaveFromClasses, leaveActiveClasses, leaveToClasses, enterToClasses;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (controller.transitioned) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              controller.transitioned = false;
              controllerLeave && controllerLeave(event);
              leaveFromClasses = getAttribute('leaveFrom', options, dataset);
              leaveActiveClasses = getAttribute('leaveActive', options, dataset);
              leaveToClasses = getAttribute('leaveTo', options, dataset);
              enterToClasses = getAttribute('enterTo', options, dataset);

              if (!removeToClasses) {
                removeClasses(targetElement, enterToClasses);
              }

              _context2.next = 11;
              return transition(targetElement, leaveFromClasses, leaveActiveClasses, leaveToClasses, hiddenClass, preserveOriginalClass, removeToClasses);

            case 11:
              if (!!hiddenClass) {
                targetElement.classList.add(hiddenClass);
              }

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _leave.apply(this, arguments);
  }

  function toggleTransition(event) {
    controllerToggleTransition && controllerToggleTransition(event);

    if (controller.transitioned) {
      leave();
    } else {
      enter();
    }
  }

  function transition(_x3, _x4, _x5, _x6, _x7, _x8, _x9) {
    return _transition.apply(this, arguments);
  }

  function _transition() {
    _transition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(element, initialClasses, activeClasses, endClasses, hiddenClass, preserveOriginalClass, removeEndClasses) {
      var stashedClasses;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // if there's any overlap between the current set of classes and initialClasses/activeClasses/endClasses,
              // we should remove them before we start and add them back at the end
              stashedClasses = [];

              if (preserveOriginalClass) {
                initialClasses.forEach(function (cls) {
                  return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
                });
                activeClasses.forEach(function (cls) {
                  return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
                });
                endClasses.forEach(function (cls) {
                  return element.classList.contains(cls) && cls !== hiddenClass && stashedClasses.push(cls);
                });
              } // Add initial class before element start transition


              addClasses(element, initialClasses); // remove the overlapping classes

              removeClasses(element, stashedClasses); // Add active class before element start transition and maitain it during the entire transition.

              addClasses(element, activeClasses);
              _context3.next = 7;
              return nextAnimationFrame();

            case 7:
              // remove the initial class on frame after the beginning of the transition
              removeClasses(element, initialClasses); // add the endClass on frame after the beginning of the transition

              addClasses(element, endClasses); // dynamically comput the duration of the transition from the style of the element

              _context3.next = 11;
              return afterTransition(element);

            case 11:
              // remove both activeClasses and endClasses
              removeClasses(element, activeClasses);

              if (removeEndClasses) {
                removeClasses(element, endClasses);
              } // restore the overlaping classes


              addClasses(element, stashedClasses);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _transition.apply(this, arguments);
  }

  function initialState() {
    controller.transitioned = transitioned;

    if (transitioned) {
      if (!!hiddenClass) {
        targetElement.classList.remove(hiddenClass);
      }

      enter();
    } else {
      if (!!hiddenClass) {
        targetElement.classList.add(hiddenClass);
      }

      leave();
    }
  }

  function addClasses(element, classes) {
    if (classes.length > 0) {
      var _element$classList;

      (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(classes));
    }
  }

  function removeClasses(element, classes) {
    if (classes.length > 0) {
      var _element$classList2;

      (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(classes));
    }
  }

  initialState();
  Object.assign(controller, {
    enter: enter,
    leave: leave,
    toggleTransition: toggleTransition
  });
  return [enter, leave, toggleTransition];
};

function getAttribute(name, options, dataset) {
  var datasetName = "transition".concat(name[0].toUpperCase()).concat(name.substr(1));
  var datasetAlpineName = alpineNames[name];
  var classes = options[name] || dataset[datasetName] || dataset[datasetAlpineName] || ' ';
  return isEmpty(classes) ? [] : classes.split(' ');
}

function afterTransition(_x10) {
  return _afterTransition.apply(this, arguments);
}

function _afterTransition() {
  _afterTransition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(element) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", new Promise(function (resolve) {
              var duration = Number(getComputedStyle(element).transitionDuration.split(',')[0].replace('s', '')) * 1000;
              setTimeout(function () {
                resolve(duration);
              }, duration);
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _afterTransition.apply(this, arguments);
}

function nextAnimationFrame() {
  return _nextAnimationFrame.apply(this, arguments);
}

function _nextAnimationFrame() {
  _nextAnimationFrame = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new Promise(function (resolve) {
              requestAnimationFrame(function () {
                requestAnimationFrame(resolve);
              });
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _nextAnimationFrame.apply(this, arguments);
}

function isEmpty(str) {
  return str.length === 0 || !str.trim();
}